import { Component, Input } from '@angular/core';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

@Component({
  selector: 'app-boolean-cell',
  standalone: true,
  template: `{{ params.value ? 'Sí' : 'No' }}`,
})
export class BooleanCellComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any>;
}